module.exports = __webpack_public_path__ + "img/location-empty.fefdc5d2.svg";